import { Box, type BoxProps } from "@drone-js/core";
import type { FunctionComponent, PropsWithChildren } from "react";

interface Props extends PropsWithChildren, Omit<BoxProps, "display" | "flexDirection"> {
    direction: "vertical" | "horizontal";
}

export const Stack: FunctionComponent<Props> = ({ direction, ...rest }) => {
    return <Box display="flex" flexDirection={direction === "vertical" ? "column" : "row"} {...rest} />;
};

export const VStack: FunctionComponent<Omit<Props, "direction">> = (props) => <Stack direction="vertical" {...props} />;
export const HStack: FunctionComponent<Omit<Props, "direction">> = (props) => (
    <Stack direction="horizontal" {...props} />
);
